/**
 * Right-rail of the external single-order layout: Patient + Provider info grids.
 *
 * @module singleOrderForExternal/components/OrderSideDetailsPanel
 */
import InfoGrid from "../../../components/infoGrid/infoGrid";
import { InfoGridData } from "../../../data-model/infoGrid";

interface OrderSideDetailsPanelProps {
  patientData: InfoGridData[] | null;
  providerData: InfoGridData[] | null;
}

/**
 * @param props - Patient and provider info-grid rows
 * @returns The stacked patient + provider detail cards
 */
const OrderSideDetailsPanel = ({
  patientData,
  providerData,
}: OrderSideDetailsPanelProps) => (
  <div className="single-order-for-external--content--secondary__right">
    <div className="single-order-for-external--content--secondary__right--patient-details">
      Patient Details
      <InfoGrid infoGridData={patientData} />
    </div>
    <div className="single-order-for-external--content--secondary__right--provider-details">
      Provider Details
      <InfoGrid infoGridData={providerData} />
    </div>
  </div>
);

export default OrderSideDetailsPanel;
